var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgDataSource(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 20 20",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Path 2") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17.057 1.724H13.62a.862.862 0 1 1 0-1.724h5.517c.476 0 .862.386.862.862V6.38a.862.862 0 1 1-1.724 0V2.943l-8.528 8.529a.862.862 0 0 1-1.22-1.22l8.529-8.528zm-7.23 0a.862.862 0 0 1 0 1.724H3.622c-1.048 0-1.897.85-1.897 1.897v11.034c0 1.048.85 1.897 1.897 1.897h11.034c1.048 0 1.897-.85 1.897-1.897v-6.207a.862.862 0 0 1 1.724 0v6.207c0 2-1.621 3.621-3.62 3.621H3.62C1.62 20 0 18.379 0 16.38V5.344c0-2 1.621-3.62 3.62-3.62h6.208z",
    fillRule: "nonzero",
    fill: "#6B8599"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgDataSource);
export default __webpack_public_path__ + "static/media/data-source.7d4bbb1db3fc7071087d6f2a66de5c8a.svg";
export { ForwardRef as ReactComponent };